/* constants 

This defines all constants (usually strings) used in the website as, for example, in input labels and 
placeholders. */ 

// API URL
const URL_API = "https://5e9935925eabe7001681c856.mockapi.io/api/v1/catalog";

// Placeholders
const IMAGE_PLACEHOLDER = "https://via.placeholder.com/470x594/FFFFFF/?text=Imagem+Indisponível"

// Labes related to ShoppingCart container
const LABEL_CART_TITLE = "Seu carrinho de compras";
const EMPTY_CART = "Seu carrinho está vazio :/";
const LABEL_CART_PRODUCT_SIZE = "Tam.:";
const LABEL_CART_REMOVE_PRODUCT = "Remover item";
const LABEL_TOTAL_ORDER = "Total:";
const LABEL_CLOSE_ORDER_BUTTON = "Fechar Pedido";

// Labes from ProductDetails page
const PRODUCT_DETAILS_TITLE = "Escolha uma peça"
const LABEL_PRODUCT_SIZES = "Selecione um tamanho";
const LABEL_PAYMENT_OPTIONS = "Em até";
const LABEL_ADD_TO_CART_BUTTON = "Adicionar à sacola";
const DISCCOUNT_TEXT = "de desconto";

// Labels in SearchWindow 
const SEARCH_WINDOW_TITLE = "Encontre um produto";
const SEARCH_INPUT_PLACEHOLDER = "Digite o nome do produto";
const NO_SEARCH_RESULTS = "Nenhum resultado encontrado";

export{
    URL_API,
    LABEL_CART_TITLE,
    EMPTY_CART,
    LABEL_CART_PRODUCT_SIZE,
    LABEL_CART_REMOVE_PRODUCT,
    PRODUCT_DETAILS_TITLE,
    LABEL_PRODUCT_SIZES,
    LABEL_PAYMENT_OPTIONS,
    LABEL_ADD_TO_CART_BUTTON,
    LABEL_TOTAL_ORDER,
    LABEL_CLOSE_ORDER_BUTTON,
    DISCCOUNT_TEXT,
    IMAGE_PLACEHOLDER,
    SEARCH_WINDOW_TITLE,
    SEARCH_INPUT_PLACEHOLDER,
    NO_SEARCH_RESULTS
}